export default "__VITE_ASSET__3Lf1ZXDQ__"